import app from 'app/app'
import { IFrame, reactive } from 'alkali'

export class Chat extends IFrame('.chat#intercom-id-frame') {
	static dialog: Chat
	static get instance() {
		if (!this.dialog) {
			document.body.append(this.dialog = new Chat())
		}
		return this.dialog
	}
	public visible
	private loaded: Promise<void>
	created(properties) {
		this.visible = reactive(false)
		properties.display = this.visible
		const userInfo = app.user
		this.src = `/chat.html?email=${encodeURIComponent(userInfo.Email)}&user_id=${userInfo.Id}&name=${encodeURIComponent(userInfo.FirstName + ' ' +
				userInfo.LastName + ' (' +
				userInfo.Division + ', ' +
				userInfo.Client.Name + ')')}`
		window.addEventListener('message', event => {
			if (event.data == 'IntercomClosed')
				this.toggle()
		})
	}
	toggle(msg?: boolean | string) {
		const visible = !!(msg ?? !this.visible.valueOf())
		localStorage[visible ? 'setItem' : 'removeItem']('chat-state', 'open')
		this.visible.put(visible)
		if (visible) {
			this.loaded || (this.loaded = new Promise(resolve =>
				window.addEventListener('message', event =>
					event.data == 'IntercomLoaded' && resolve()
				, { once: true })
			))
		}
		if (visible) {
			this.loaded.then(() => {
				if (typeof msg == 'string') {
					this.contentWindow.postMessage({ event: 'MsgIntercom', msg }, location.origin)
				} else {
					this.contentWindow.postMessage('ShowIntercom', location.origin)
				}
			})
		}
	}
	static toggle(msg?: boolean | string) {
		if (!!msg || Chat.dialog) Chat.instance.toggle(msg)
	}
}